import React, { useEffect } from "react";
// import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router";
import PropTypes from "prop-types";
import { authenStorage } from "src/common/Storage";
import { isExpired } from "react-jwt";

// Example of user roles: ['GUEST', 'USER', 'ADMIN'];

function SecureGate({ children }) {
  // const session = useSelector((state) => state.session);
  const history = useHistory();

  useEffect(() => {
    const authen = authenStorage.getAuthen();
    if (!authen) {
      authenStorage.clear();
      window.location.href = `${process.env.REACT_APP_POTAL_WEBSITE}`;
      console.log("clear");
      return;
    }
    setInterval(() => {
      if (isExpired(authen.accessToken || "")) {
        authenStorage.clear();
        window.location.href = `${process.env.REACT_APP_POTAL_WEBSITE}`;
        return;
      }
    }, 1000);
  }, [history]);

  return <>{children}</>;
}

SecureGate.propTypes = {
  children: PropTypes.node,
};

export default SecureGate;
